<template>
  <div class="landing-wrap">
    <div class="inner">
      <h2><em>온누리상품권으로</em>주문하는 배달생활</h2>
      <div class="img-payment">
        <img src="@/assets/img/img_payment.png" alt="복합결제 가능!" />
      </div>
      <p>
        <span class="img-logo"
        ><img src="@/assets/img/img_logo_suncheon.png" alt="순천시" /></span
        >에서 시작하세요!!!
      </p>
      <a class="btn" @click="moveStore">주문하기</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AppRenderingPage',
  data () {
    return {
      fallbackTimer: null,
      autoOpenTimer: null,
      appOpened: false,
      confirmDialogShown: false
    }
  },
  mounted () {
    this.autoOpenTimer = setTimeout(() => {
      this.openApp()
    }, 3000)
  },
  beforeDestroy () {
    if (this.autoOpenTimer) {
      clearTimeout(this.autoOpenTimer)
    }
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer)
    }
  },
  methods: {
    getMobileOS () {
      const ua = navigator.userAgent || navigator.vendor || window.opera
      if (/android/i.test(ua)) {
        return 'android'
      }
      if (/iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return 'iOS'
      }
      return 'other'
    },
    moveStore () {
      const androidPackage = 'info.seeroo.onuriorder'
      const playStoreUrl = `https://play.google.com/store/apps/details?id=${androidPackage}`
      const iosAppStoreUrl = 'https://apps.apple.com/kr/app/id6740787331'
      const os = this.getMobileOS()

      if (os === 'android') {
        window.location.href = playStoreUrl
      } else {
        window.location.href = iosAppStoreUrl
      }
    },
    openApp () {
      // 자동 실행 타이머 취소
      if (this.autoOpenTimer) {
        clearTimeout(this.autoOpenTimer)
        this.autoOpenTimer = null
      }

      const schemeName = 'onnuriorder'
      const androidPackage = 'info.seeroo.onuriorder'
      const playStoreUrl = `https://play.google.com/store/apps/details?id=${androidPackage}`
      const iosAppStoreUrl = 'https://apps.apple.com/kr/app/id6740787331'
      const os = this.getMobileOS()

      // 기존 타이머 정리 및 플래그 리셋
      if (this.fallbackTimer) {
        clearTimeout(this.fallbackTimer)
        this.fallbackTimer = null
      }
      this.appOpened = false

      if (os === 'android') {
        // Android: URL Scheme 사용
        window.location.href = `${schemeName}://`

        // 앱 열림 감지 함수
        const onVisibilityChange = () => {
          if (document.hidden) {
            if (this.fallbackTimer) {
              clearTimeout(this.fallbackTimer)
              this.fallbackTimer = null
            }
            document.removeEventListener('visibilitychange', onVisibilityChange)
          }
        }
        document.addEventListener('visibilitychange', onVisibilityChange)

        // fallback: 앱이 열리지 않으면 스토어로 이동
        this.fallbackTimer = setTimeout(() => {
          if (!document.hidden) {
            document.removeEventListener('visibilitychange', onVisibilityChange)
            window.location.href = playStoreUrl
          }
        }, 2000)
      } else if (os === 'iOS') {
        // iOS: URL Scheme 사용
        // confirm 창 메시지:
        // - 미설치: 'App Store'에서 이 페이지를 열겠습니까?
        // - 설치: '앱이름'에서 이 페이지를 열겠습니까?
        const urlScheme = `${schemeName}://`
        this.confirmDialogShown = false

        // blur 이벤트: Safari에서 confirm 창이 뜨면 window가 blur 상태가 됨
        const handleBlur = () => {
          this.confirmDialogShown = true
          // confirm 창이 떴으므로 기존 타이머 취소하고 재설정
          if (this.fallbackTimer) {
            clearTimeout(this.fallbackTimer)
            this.fallbackTimer = null
          }
        }

        // focus 이벤트: confirm 창에서 돌아왔을 때 (취소를 눌렀을 가능성)
        const handleFocus = () => {
          // confirm 창에서 돌아왔는데 페이지가 여전히 보이면 취소를 눌렀거나 앱이 열리지 않은 것
          // 추가로 체크할 시간을 줌
          if (this.confirmDialogShown && !document.hidden) {
            if (this.fallbackTimer) {
              clearTimeout(this.fallbackTimer)
            }
            // 사용자가 선택할 시간을 더 주고 체크
            this.fallbackTimer = setTimeout(() => {
              if (!document.webkitHidden && !document.hidden) {
                window.removeEventListener('blur', handleBlur)
                window.removeEventListener('focus', handleFocus)
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                window.removeEventListener('pagehide', handlePageHide)
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                document.removeEventListener('visibilitychange', handleVisibilityChange)
                window.location.href = iosAppStoreUrl
              }
            }, 1500)
          }
        }

        // 앱이 열렸는지 감지하는 핸들러
        const handlePageHide = () => {
          if (this.fallbackTimer) {
            clearTimeout(this.fallbackTimer)
            this.fallbackTimer = null
          }
          window.removeEventListener('blur', handleBlur)
          window.removeEventListener('focus', handleFocus)
          window.removeEventListener('pagehide', handlePageHide)
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          document.removeEventListener('visibilitychange', handleVisibilityChange)
        }

        const handleVisibilityChange = () => {
          if (document.hidden) {
            if (this.fallbackTimer) {
              clearTimeout(this.fallbackTimer)
              this.fallbackTimer = null
            }
            window.removeEventListener('blur', handleBlur)
            window.removeEventListener('focus', handleFocus)
            window.removeEventListener('pagehide', handlePageHide)
            document.removeEventListener('visibilitychange', handleVisibilityChange)
          }
        }

        // blur/focus 이벤트로 confirm 창 감지
        window.addEventListener('blur', handleBlur)
        window.addEventListener('focus', handleFocus)
        // pagehide 이벤트는 앱이 열릴 때 발생 (확인창 이후에도)
        window.addEventListener('pagehide', handlePageHide)
        document.addEventListener('visibilitychange', handleVisibilityChange)

        // URL Scheme으로 앱 열기 시도
        window.location.href = urlScheme

        // confirm 창이 떴으면 blur 이벤트에서 처리하고, 안 떴으면 여기서 처리
        this.fallbackTimer = setTimeout(() => {
          if (!this.confirmDialogShown) {
            if (!document.webkitHidden && !document.hidden) {
              window.removeEventListener('blur', handleBlur)
              window.removeEventListener('focus', handleFocus)
              window.removeEventListener('pagehide', handlePageHide)
              document.removeEventListener('visibilitychange', handleVisibilityChange)
              window.location.href = iosAppStoreUrl
            }
          }
          // confirm 창이 떴으면 blur/focus 이벤트에서 처리
        }, 1000)
      } else {
        // 기타 플랫폼은 스토어로 직접 이동
        window.location.href = playStoreUrl
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.landing {
  &-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100dvh;
    .inner {
      padding: 20px 24px;
    }
    img {
      max-width: 100%;
      vertical-align: top;
    }
    h2 {
      margin-bottom: 60px;
      font-size: 28px;
      font-weight: 700;
      line-height: 1.43;
      text-align: center;
      em {
        display: block;
        color: var(--primary);
        font-weight: 700;
      }
    }
    .img {
      &-payment {
        width: 280px;
        margin-bottom: 16px;
      }
      &-logo {
        display: inline-block;
        width: 90px;
        margin-top: -2px;
      }
    }
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      font-size: 16px;
    }
    .btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 48px;
      margin-top: 32px;
      background-color: var(--primary);
      font-size: 20px;
      font-weight: 700;
      color: #fff;
      border-radius: 24px;
    }
  }
}
</style>
